module.exports = __webpack_public_path__ + "static/media/Sport.c6526eb9.png";